import React from "react";
import  CategoryLayer  from "../components/Category/CategoryLayer";
import MasterLayout from "../masterLayout/MasterLayout";

export const CategoryPage = () => {
  return (
    <MasterLayout>
      <CategoryLayer />
    </MasterLayout>
  );
};
